<template>
  <section class="v2-password">
    <div class="v2-password__header">
      <p class="v2-overline">Seguridad</p>
      <h2 class="v2-headline v2-headline--display-md">Cambiar Contraseña</h2>
      <p class="v2-body v2-body--md v2-body--muted">
        Actualiza la contraseña que utilizas para acceder a tu cuenta.
      </p>
    </div>

    <v-form ref="form" class="v2-password__form" @submit.prevent="submit">
      <v-text-field
        v-model="form.oldPassword"
        label="Contraseña actual"
        type="password"
        autocomplete="current-password"
        outlined
        dense
        :rules="passwordRules"
        :disabled="saving"
      />
      <v-text-field
        v-model="form.newPassword"
        label="Nueva contraseña"
        :type="showNewPassword ? 'text' : 'password'"
        autocomplete="new-password"
        outlined
        dense
        :append-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
        :rules="newPasswordRules"
        :disabled="saving"
        @click:append="showNewPassword = !showNewPassword"
      />
      <v-text-field
        v-model="form.confirmPassword"
        label="Confirmar nueva contraseña"
        :type="showConfirmPassword ? 'text' : 'password'"
        autocomplete="new-password"
        outlined
        dense
        :append-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
        :rules="confirmPasswordRules"
        :disabled="saving"
        @click:append="showConfirmPassword = !showConfirmPassword"
      />

      <div class="v2-password__actions">
        <v-btn
          type="submit"
          color="accent"
          rounded
          :loading="saving"
          :disabled="saving"
        >
          <v-icon left>mdi-lock-reset</v-icon>
          Actualizar contraseña
        </v-btn>
      </div>
    </v-form>
  </section>
</template>

<script>
import Vue from "vue";
import { mapMutations } from "vuex";
import Endpoints from "@/share/Endpoints";
import { validations } from "@/share/validations";

export default {
  name: "ChangePasswordTab",
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      saving: false,
      showNewPassword: false,
      showConfirmPassword: false,
    };
  },
  computed: {
    passwordRules() {
      return validations.password({ name: "contraseña actual", required: true });
    },
    newPasswordRules() {
      return [
        ...validations.newPasswordRule(),
        (value) =>
          value !== this.form.oldPassword ||
          "La nueva contraseña no puede ser igual a la actual",
      ];
    },
    confirmPasswordRules() {
      return [
        (value) => !!value || "La confirmación de contraseña es requerida",
        (value) =>
          value === this.form.newPassword || "Las contraseñas deben ser iguales",
      ];
    },
  },
  methods: {
    ...mapMutations("notification", ["show"]),
    getErrorMessage(error) {
      return (
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "No se pudo actualizar la contraseña"
      );
    },
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      try {
        await Vue.axios.put(Endpoints.usersUpdatePassword, {
          user: {
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword,
          },
        });

        this.$refs.form.reset();
        this.show({
          text: "Contraseña actualizada exitosamente",
          color: "success",
          time: 3000,
        });
      } catch (error) {
        this.show({
          text: this.getErrorMessage(error),
          color: "error",
          time: 3000,
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.v2-password {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  padding: var(--space-6);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
}

.v2-password__header {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.v2-password__header h2,
.v2-password__header p {
  margin: 0;
}

.v2-password__form {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 640px;
}

.v2-password__actions {
  display: flex;
  justify-content: flex-end;
  padding-top: var(--space-2);
}

@media (max-width: 600px) {
  .v2-password {
    padding: var(--space-4);
  }

  .v2-password__actions {
    justify-content: stretch;
  }

  .v2-password__actions .v-btn {
    width: 100%;
  }

}
</style>
